import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
const JuniorLibrary = () => {
  useEffect(() => {
    document.title = "Junior Library -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home - Click Here</Link>{" "}
          </li>
          <li>TAFS Library </li>
          <li>Junior Library</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Junior Library </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-3 col-xl-4 col-lg-4">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Importance-reading.pdf"
                  target="_blank"
                >
                  {" "}
                  Importance of reading{" "}
                </Link>{" "}
              </div>
            </div>
            <div className="col-xxl-3 col-xl-4 col-lg-4">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/which-book-pick.pdf"
                  target="_blank"
                >
                  {" "}
                  Do you know which book to pick?{" "}
                </Link>{" "}
              </div>
            </div>
            <div className="col-xl-4 col-lg-4">
              <div className="linktab">
                {" "}
                <Link
                  to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/right-book-you.pdf"
                  target="_blank"
                >
                  {" "}
                  How to know if it is the right book for you?{" "}
                </Link>{" "}
              </div>
            </div>

            <h6> BOOK REVIEW FORMS </h6>

            <p>
              {" "}
              Dear students, <br />
              Would you like to share your views about a book you have read?{" "}
              <br />
              We are giving you a choice of 4 forms. <br />
              Please select ANY ONE of the forms, write a review and submit it
              to your class teacher. <br />
              Click to view or print the form{" "}
            </p>

            <div className="col-lg-12">
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/form1.pdf"
                    target="_blank"
                  >
                    {" "}
                    FORM 1 - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/form2.pdf"
                    target="_blank"
                  >
                    {" "}
                    FORM 2 - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/form3.pdf"
                    target="_blank"
                  >
                    {" "}
                    FORM 3 - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/form4.pdf"
                    target="_blank"
                  >
                    {" "}
                    FORM 4 - Click Here{" "}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h6>Click here to read some book reviews by students</h6>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review ' Thea Stilton and the secret of the fairies'
                    Avantika Dey 4E - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Dinosaur Adventure' Aadya Upadhyay 5D - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview3.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Five fall into adventure' Inaya Khan 4E - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview4.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Five on a Treasure Island' Animesh Garg 4B -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview5.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Great Stories for children' Advaith narayan 4C
                    - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview6.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review 'Great stories for children' Dhruv Roy 4C -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview7.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Great stories for children' Saachi Chavan 4E -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview8.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Blue Umbrella' anurag Kumar 4C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview9.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Blue Umbrella' Prateek 4C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview10.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The little Red Hen' Viraj Yadav 5E - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview11.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Twits' Anay Singh Kushwaha 5A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview12.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Three little pigs' Tanish Saini 3C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview13.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'What a Song' Aarohi Nanda 4B - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview14.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'Best of famous fairy tales' Tanish Pannu 4C -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview15.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'Great Stories for Children' Aarohi Nanda 4B -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview16.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'Little Red Hen' Ishaan Singh 4C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview17.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'Red pizzas for a blue count' Imran Hussain 4 -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview18.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'The 500 hats of Bartholomew Cubbins'Aarohi Nanda
                    4B - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview19.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review'The National Flag' Vibhor Chaturvedi 4E - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview20.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'The Secret Garden' Osheen Kaushik 4B - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview21.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review' What a Song' Revant Singh 4C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview22.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review ' Diary of a Wimpy Kid' Idhant Nandi 4E - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview23.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Cat and Mouse in a Haunted House' Mishka Dhull
                    4E - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview24.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Dinosaur Disaster' Pranjal 4A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview25.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Five on a Treasure Island' Vivaan Upreti 4C -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview26.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'George's Cosmic Treasure Hunt' Anurag Gupta 4E
                    - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview27.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Blue Umbrella' Sanvi Monga 4E - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview28.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Blue Umbrella' Ashmita Singh 4E - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview29.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Tintin and the Lake of Sharks' Mehith Shivkumar
                    4E - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview30.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Tintin and the Shooting Star' Revant Singh 4C -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview31.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review' Chatur Dhobi' Rashmi Kumari 5E - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview32.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'I am too fond of my fur' Kabeer Shurani 4C -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview33.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Cat in the Hat' Yuvika 4C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview34.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'The Cat in the Hat' Harsh Dwivedi 4C - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview35.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review The Little Red Hen Arunabh Jha 4C - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview36.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review'Tintin and the secret of the Unicorn' Tanish
                    Shukla 5D - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview37.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'Five Run Away Together' Shayna Rath 3A - Click
                    Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview38.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review 'GS-Hands Off Cheddar Face' Nishka Bhat 5A -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview39.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'GS-The Curse of the Cheeese Pyramid' Ishayu
                    Bhowmick 5A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview40.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'GS-The Journey through Time 'Sanchit Patel 4E -
                    Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview41.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book review 'How I Taught my Grandmother to Read and other
                    stories' Shayna Rath 4A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview42.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review' Charlie and the Chocolate Factory' Aliya
                    Parween 4A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview43.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review 'The Blue Umbrella ' Priya Patni 4A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview44.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review' The King's Stilts' Swayamdeep 4A - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/bookreview45.pdf"
                    target="_blank"
                  >
                    {" "}
                    Book Review 'What a Song' Priyanka Pandey 4A- Click
                    Here{" "}
                  </Link>
                </li>
              </ul>
              <h6>E-books (English) </h6>
              <p>For the very young reader </p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Red-Hen.pdf"
                    target="_blank"
                  >
                    {" "}
                    The little Red Hen - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Zoo.pdf"
                    target="_blank"
                  >
                    {" "}
                    If I Ran the Zoo - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/LittlePigs.pdf"
                    target="_blank"
                  >
                    {" "}
                    Three Little Pigs - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Greeneggs.pdf"
                    target="_blank"
                  >
                    {" "}
                    Green eggs and ham by Dr Seuss - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/ABC-Seuss.pdf"
                    target="_blank"
                  >
                    {" "}
                    ABC By Dr Seuss - Click Here
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Nutty-Seuss.pdf"
                    target="_blank"
                  >
                    {" "}
                    Nutty numbers Dr Seuss- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>The Adventures of Tintin</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/About-the-Series.pdf"
                    target="_blank"
                  >
                    {" "}
                    About the Series - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tintin-Picaros.pdf"
                    target="_blank"
                  >
                    {" "}
                    Tintin and the Picaros- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tintin-America.pdf"
                    target="_blank"
                  >
                    {" "}
                    Tintin in America- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tintin-Shooting.pdf"
                    target="_blank"
                  >
                    {" "}
                    Tintin and the Shooting star- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tintin-Congo.pdf"
                    target="_blank"
                  >
                    {" "}
                    Tintin in Congo- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tintin-Blue.pdf"
                    target="_blank"
                  >
                    {" "}
                    Tintin and the Blue Lotus- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Tintin-Soviets.pdf"
                    target="_blank"
                  >
                    {" "}
                    Tintin in the land of the Soviets- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>Asterix Comic Series</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Asterix1.pdf"
                    target="_blank"
                  >
                    {" "}
                    About the Series - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Asterix2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Asterix and the Falling Sky - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Asterix3.pdf"
                    target="_blank"
                  >
                    {" "}
                    Asterix and the Magic Carpet - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Asterix4.pdf"
                    target="_blank"
                  >
                    {" "}
                    Asterix and the Big Fight - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Asterix5.pdf"
                    target="_blank"
                  >
                    {" "}
                    Asterix and the Secret Weapon - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Asterix6.pdf"
                    target="_blank"
                  >
                    {" "}
                    Asterix at the Olympic Games- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>The Famous Five Series</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/fiveseries1.pdf"
                    target="_blank"
                  >
                    {" "}
                    About the books- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/fiveseries2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Five on a Treasure Island- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/fiveseries3.pdf"
                    target="_blank"
                  >
                    {" "}
                    Five go to Smuggler’s Top- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/fiveseries4.pdf"
                    target="_blank"
                  >
                    {" "}
                    Five Go off to Camp- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/fiveseries5.pdf"
                    target="_blank"
                  >
                    {" "}
                    Five Run Away Togethe- Click Herer
                  </Link>
                </li>
              </ul>
              <p>Ruskin Bond Books</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ruskin1.pdf"
                    target="_blank"
                  >
                    {" "}
                    About the author - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ruskin2.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Blue Umbrella - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ruskin3.pdf"
                    target="_blank"
                  >
                    {" "}
                    The India I love - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ruskin4.pdf"
                    target="_blank"
                  >
                    {" "}
                    Animal Stories - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Ruskin5.pdf"
                    target="_blank"
                  >
                    {" "}
                    Great Stories for children- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>Roald Dahl Books</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Roald-Dahl-Books1.pdf"
                    target="_blank"
                  >
                    {" "}
                    About the author- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Roald-Dahl-Books2.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Twits- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Roald-Dahl-Books3.pdf"
                    target="_blank"
                  >
                    {" "}
                    Matilda- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>Good Reads by Other Authors</p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/grandmother-short-stories.pdf"
                    target="_blank"
                  >
                    How I taught my grandmother to read & other short stories(
                    Sudha Murthy)
                  </Link>
                </li>{" "}
              </ul>
              <p>Evergreen Classics</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/AdventuresTom-Sawyer.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Adventures of Tom Sawyer - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Treasure-Island.pdf"
                    target="_blank"
                  >
                    {" "}
                    Treasure Island- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>Folk Tales and other stories</p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Bundelkhand-story.pdf"
                    target="_blank"
                  >
                    {" "}
                    What a Song ( a Bundelkhand story){" "}
                  </Link>
                </li>{" "}
              </ul>
              <p>Dr Seuss Books</p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books1.pdf"
                    target="_blank"
                  >
                    {" "}
                    About the Author- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Bartholomew And The Ooblek By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books3.pdf"
                    target="_blank"
                  >
                    {" "}
                    Horton Hatches The Egg By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books4.pdf"
                    target="_blank"
                  >
                    {" "}
                    If I Ran The Circus By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books5.pdf"
                    target="_blank"
                  >
                    {" "}
                    The King's Stilts By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books6.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Cat In The Hat By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books7.pdf"
                    target="_blank"
                  >
                    {" "}
                    The 500 Hats By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Seuss-Books8.pdf"
                    target="_blank"
                  >
                    {" "}
                    Scrambled Eggs By Dr Seuss- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>Geronimo Stilton</p>
              <ul className="list mainlist">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton1.pdf"
                    target="_blank"
                  >
                    {" "}
                    About The Author- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Paws Off Cheddarface!- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton3.pdf"
                    target="_blank"
                  >
                    {" "}
                    I'm Too Fond Of My Fur- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton4.pdf"
                    target="_blank"
                  >
                    {" "}
                    Dinosaur Disaster- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton5.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Curse Of The Cheese Pyramid- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton6.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Mystery Of Venice- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton7.pdf"
                    target="_blank"
                  >
                    {" "}
                    Lost Treasure Of The Emerald Eye- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton8.pdf"
                    target="_blank"
                  >
                    {" "}
                    The Peculiar Pumpkin Thief- Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/Geronimo-Stilton9.pdf"
                    target="_blank"
                  >
                    {" "}
                    Red Pizzas For A Blue Count- Click Here{" "}
                  </Link>
                </li>
              </ul>
              <p>E-books (Hindi)</p>
              <ul className="list">
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/E-books-hindi1.pdf"
                    target="_blank"
                  >
                    {" "}
                    Bada murkh kaun - Click Here{" "}
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/TAFS/public/pdf/E-books-hindi2.pdf"
                    target="_blank"
                  >
                    {" "}
                    Chatur dhobi- Click Here{" "}
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JuniorLibrary;
